<template>
  <v-card class="rounded-lg elevation-0" tile>
    <v-toolbar flat class="pt-2">
      <v-toolbar-title v-if="title" class="title font-weight-normal primary--text">
        <v-icon>{{ icon }}</v-icon>
        {{ title }}
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-progress-circular v-if="loading || iLoading" indeterminate color="primary lighten-2"></v-progress-circular>
      <template v-else>
        <slot name="action">
          <v-text-field
            outlined
            v-show="search && $vuetify.breakpoint.smAndUp"
            dense
            class="mx-2"
            v-model="textSearch"
            clearable
            placeholder
            append-icon="mdi-magnify"
            append-icon-color="primary"
            @click:append="$emit('search', textSearch)"
            @click:clear="$emit('search', null)"
            label
            single-line
            hide-details
            @keyup.enter="$emit('search', textSearch)"
          ></v-text-field>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="mx-1"
                color="primary"
                v-on="on"
                depressed
                v-if="add && $vuetify.breakpoint.xs"
                @click="toggleSearch = !toggleSearch"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <span>{{ addHint }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="mx-1"
                color="primary"
                :disabled="addDisable"
                v-on="on"
                depressed
                v-if="add"
                @click="$emit('add')"
              >
                <v-icon>mdi-plus</v-icon>
                {{ $vuetify.breakpoint.xs ? "" : addText }}
              </v-btn>
            </template>
            <span>{{ addHint }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn class="mx-1" color="error" v-on="on" depressed v-if="deleteData" @click="$emit('delete')">
                <v-icon>mdi-delete</v-icon>
                {{ $vuetify.breakpoint.xs ? "" : deleteText }}
              </v-btn>
            </template>
            <span>{{ deleteHint }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn class="mx-1" color="primary" v-on="on" depressed v-if="edit" @click="$emit('edit')">
                <v-icon>mdi-pencil-outline</v-icon>Ubah
              </v-btn>
            </template>
            <span>{{ $vuetify.breakpoint.xs ? "" : "Ubah Data" }}</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" v-on="on" v-if="refresh" icon @click="doRefresh">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>Muat Ulang Tayangan</span>
          </v-tooltip>
          <v-btn small class="mr-0 pr-0" v-if="close" icon @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-menu v-if="more" left>
            <template v-slot:activator="{ on }">
              <v-btn small class="mr-0 pr-0" icon v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-card width="200">
              <slot name="more_menu"></slot>
            </v-card>
          </v-menu>
        </slot>
        <slot name="action_ext"></slot>
      </template>
    </v-toolbar>
    <!-- <v-divider></v-divider> -->

    <slot name="under_toolbar">
      <v-row justify="end">
        <v-col cols="12" sm="12" md="12" xl="12" v-if="toggleSearch">
          <v-text-field
            class="mx-2"
            outlined
            dense
            v-model="textSearch"
            clearable
            append-icon="mdi-magnify"
            @click:append="$emit('search', textSearch)"
            @click:clear="$emit('search', null)"
            label="Tulis Pencarian"
            single-line
            hide-details
            @keyup.enter="$emit('search', textSearch)"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="end" v-if="filter && toggleFilter">
        <v-col cols="12">
          <v-dialog ref="filterData" v-model="dialog" max-width="500">
            <v-card class="pa-2">
              <v-card-title class="headline pl-4 primary--text">Filter Berdasarkan</v-card-title>
              <v-card-text>
                <v-form @submit.prevent data-vv-scope="form" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" class="pa-1">
                      <v-select
                        clearable
                        :items="itemStatuses"
                        label="Status"
                        name="Status"
                        placeholder="Pilih Status"
                        v-model="status"
                        hint="Pilih Status"
                        data-vv-name="status"
                        data-vv-as="Status"
                        item-text="nama"
                        item-value="id"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12" class="pa-1" v-if="filterTanggal">
                      <v-select
                        clearable
                        :items="itemTanggals"
                        label="Tanggal"
                        name="Tanggal"
                        placeholder="Tanggal"
                        v-model="tanggal"
                        hint="Urutkan berdasarkan tanggal"
                        data-vv-name="bobot"
                        data-vv-as="Tanggal"
                        item-text="nama"
                        item-value="id"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>

              <v-card-actions class="pr-4 pb-4">
                <v-spacer></v-spacer>
                <v-btn
                  name="simpan"
                  depressed
                  color="primary"
                  @click="
                    applyFilter({
                      status: status,
                      tanggal: tanggal
                    })
                  "
                >
                  <v-icon>mdi-check</v-icon>Terapkan
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <v-row justify="start" v-if="customFilter">
        <v-col cols="12" sm="3" md="3" lg="3" xl="2" v-if="dateRange">
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateFromFormatted"
                label="Mulai"
                prepend-icon="mdi-calendar-range"
                color="primary"
                class="pt-0 mt-1 ml-2 mr-2"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="from" :max="maxFrom" no-title @input="process"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="3" md="3" lg="3" xl="2" v-if="dateRange">
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateToFormatted"
                label="Sampai"
                class="pt-0 mt-1 ml-2 mr-2"
                prepend-icon="mdi-calendar-range"
                color="primary"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="to" :min="minTo" :max="maxTo" no-title @input="process"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </slot>
    <v-card-text :class="{ 'pa-0': noPadding }">
      <slot></slot>
    </v-card-text>
    <v-card-actions v-if="footer">
      <slot name="footer" :loading="loading"></slot>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "m-card",
  components: {},
  props: {
    icon: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    dateRange: {
      type: Boolean,
      default: false
    },
    add: {
      type: Boolean,
      default: false
    },
    addText: {
      type: String,
      default: "Tambah"
    },
    addHint: {
      type: String,
      default: "Tambah"
    },
    addDisable: {
      type: Boolean,
      default: false
    },
    deleteData: {
      type: Boolean,
      default: false
    },
    deleteText: {
      type: String,
      default: "Hapus"
    },
    deleteHint: {
      type: String,
      default: "Hapus"
    },
    edit: {
      type: Boolean,
      default: false
    },
    unduh: {
      type: Boolean,
      default: false
    },
    print: {
      type: Boolean,
      default: false
    },
    customFilter: {
      type: Boolean,
      default: false
    },
    footer: {
      type: Boolean,
      default: false
    },
    refresh: {
      type: Boolean,
      default: false
    },
    close: {
      type: Boolean,
      default: false
    },
    more: {
      type: Boolean,
      default: false
    },
    search: {
      type: Boolean,
      default: false
    },
    filter: {
      type: Boolean,
      default: false
    },
    filterTanggal: {
      type: Boolean,
      default: false
    },
    filterPeran: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    onRefresh: {
      type: Function,
      default: null
    },
    itemStatuses: {
      type: Array,
      default: () => []
    }
  },
  data: vm => ({
    iLoading: false,
    dialog: true,
    status: null,
    textSearch: null,
    toggleSearch: false,
    toggleFilter: false,
    from: new Date(),
    to: new Date().toISOString().substr(0, 10),
    maxFrom: new Date().toISOString().substr(0, 10),
    minTo: null,
    maxTo: new Date().toISOString().substr(0, 10),
    dateFromFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    dateToFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,
    menu2: false
  }),

  activated() {},
  computed: {},
  mounted() {
    let d = new Date();
    let sevenDaysAgo = d.setDate(d.getDate() - 29);
    this.from = new Date(sevenDaysAgo).toISOString().substr(0, 10);
    this.minTo = new Date(sevenDaysAgo).toISOString().substr(0, 10);
    this.process();
  },
  methods: {
    doRefresh() {
      if (this.onRefresh) {
        this.iLoading = true;
        this.onRefresh()
          .then(() => (this.iLoading = false))
          .catch(() => (this.iLoading = false));
      } else this.$emit("refresh");
    },
    process() {
      let range = {
        from: this.from,
        to: this.to
      };
      this.menu1 = false;
      this.menu2 = false;

      this.$emit("process", range);
    },
    applyFilter(data) {
      this.toggleFilter = !this.toggleFilter;
      this.$emit("filter", data);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    }
  },
  watch: {
    dialog(n) {
      if (n == false) this.toggleFilter = false;
    },
    toggleFilter(n) {
      if (n == true) {
        this.dialog = true;
      }
    },
    textSearch(textSearch) {
      if (!textSearch) {
        this.$emit("search", null);
      }
    },
    r() {
      this.u = null;
    },
    from() {
      this.dateFromFormatted = this.formatDate(this.from);
      this.minTo = new Date(this.from).toISOString().substr(0, 10);
    },
    to() {
      this.dateToFormatted = this.formatDate(this.to);
      this.maxFrom = new Date(this.to).toISOString().substr(0, 10);
    },
    labelInfo() {
      this.valueInfo = null;
    }
  }
};
</script>
